import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import type { ExternalCalendarEvent } from '@/api/calendarSync/calendarSyncApi.types';
import {
  computeAppointmentHeightPixels,
  computeAppointmentTopOffsetPixels,
} from './utils/appointmentLayout';
import { filterExternalEventDaySpansForIsoDate } from './utils/externalEvents';

interface ExternalEventOverlayProps {
  isoDate: string;
  externalEvents: ExternalCalendarEvent[];
  hourHeightPixels: number;
  isCompact?: boolean;
}

export function ExternalEventOverlay({
  isoDate,
  externalEvents,
  hourHeightPixels,
  isCompact = false,
}: ExternalEventOverlayProps) {
  const { t } = useTranslation('calendar');
  const spans = filterExternalEventDaySpansForIsoDate(externalEvents, isoDate);
  if (spans.length === 0) {
    return null;
  }
  return (
    <>
      {spans.map(function renderExternalEvent(span) {
        const topOffsetPixels = computeAppointmentTopOffsetPixels(span.startTime, hourHeightPixels);
        const heightPixels = computeAppointmentHeightPixels(
          span.startTime,
          span.endTime,
          hourHeightPixels
        );
        const title = span.title.length > 0 ? span.title : t('externalEvents.busy');
        return (
          <div
            key={span.id}
            title={title}
            className="absolute left-0 right-0 rounded-xl border border-dashed border-zooviolet bg-zoovpalelavender opacity-70 text-zoomuted px-2 py-1 overflow-hidden pointer-events-none"
            style={{ top: `${topOffsetPixels}px`, height: `${heightPixels}px`, minHeight: '20px' }}
          >
            <div className="flex items-center gap-1 text-[10px] font-semibold text-zooviolet truncate">
              <Icon name="RefreshCw" className="text-[11px] flex-shrink-0" />
              <span className="truncate">{title}</span>
            </div>
            {isCompact === false ? (
              <div className="text-[9px] text-zoomuted">
                {span.startTime}–{span.endTime}
              </div>
            ) : null}
          </div>
        );
      })}
    </>
  );
}
